// Generated types for ToolCallResponse
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ScopedNodeReadAPI, ScopedNodeWriteAPI } from '../../shared/types/scopednode';
import { ScopedNodeReadAPISchemaObject, ScopedNodeWriteAPISchemaObject } from '../../shared/types/scopednode';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface ToolCallResponseReadAPI extends Omit<ScopedNodeReadAPI, 'created_at'> {
  /** When response was created */
  created_at?: string | null;
  /** The response content from the tool (structured; stored as JSON text) */
  content?: unknown | null;
  /** Whether this is an error response */
  is_error?: boolean;
  /** Error message if this is an error response */
  tool_error_message?: string | null;
}

export interface ToolCallResponseWriteAPI extends ScopedNodeWriteAPI {
  /** The response content from the tool (structured; stored as JSON text) */
  content?: unknown | null;
  /** Whether this is an error response */
  is_error?: boolean;
  /** Error message if this is an error response */
  tool_error_message?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const ToolCallResponseReadAPISchema: z.ZodType<ToolCallResponseReadAPI> = ScopedNodeReadAPISchemaObject.omit({ 'created_at': true }).extend({
  created_at: z.string().nullable().optional(),
  content: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
  is_error: z.boolean().optional(),
  tool_error_message: z.string().nullable().optional(),
}).passthrough();

export const ToolCallResponseWriteAPISchema: z.ZodType<ToolCallResponseWriteAPI> = ScopedNodeWriteAPISchemaObject.extend({
  content: z.preprocess((v) => typeof v === 'string' ? (() => { try { return JSON.parse(v); } catch { return v; } })() : v, z.unknown().nullable()).optional(),
  is_error: z.boolean().optional(),
  tool_error_message: z.string().nullable().optional(),
}).passthrough();
